import {Button} from 'antd';

import {Locale} from '../../../../../../../../../provider/locale/localization';

import {AiGenerationStepEnum} from './ai-generation-type';
import * as styles from './ai-generation-modal.scss';

type PropsType = {
    step: AiGenerationStepEnum;
    isSubmitDisabled: boolean;
    isGeneratingSuggest: boolean;
    isApplying: boolean;
    hasActiveSuggest: boolean;
    onGenerate: () => void;
    onBack: () => void;
    onGenerateMore: () => void;
    onApply: () => void;
};

export function AiGenerationModalFooter(props: PropsType): JSX.Element | null {
    const {
        step,
        isSubmitDisabled,
        isGeneratingSuggest,
        isApplying,
        hasActiveSuggest,
        onGenerate,
        onBack,
        onGenerateMore,
        onApply,
    } = props;

    if (step === AiGenerationStepEnum.Settings) {
        return (
            <Button disabled={isSubmitDisabled} onClick={onGenerate} type="primary">
                <Locale stringKey="POSTS_AI_GENERATION__SETUP__SUBMIT" />
            </Button>
        );
    }

    if (step === AiGenerationStepEnum.Result) {
        return (
            <div className={styles.AiGenerationModal_footer}>
                <Button onClick={onBack}>
                    <Locale stringKey="BUTTON__BACK" />
                </Button>
                <Button disabled={isGeneratingSuggest} loading={isGeneratingSuggest} onClick={onGenerateMore}>
                    <Locale stringKey="POSTS_AI_GENERATION__RESULT__GENERATE_MORE_IDEAS" />
                </Button>
                <Button disabled={!hasActiveSuggest} loading={isApplying} onClick={onApply} type="primary">
                    <Locale stringKey="TEXT__SELECT" />
                </Button>
            </div>
        );
    }

    return null;
}
